import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const BenefitsRealEstate = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-list:first-of-type,for-hover:first-of-type{
                                padding-left:0!important
                            }
             .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4;
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
            
            `}</style>
      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Simplification of Complex Concepts</h3>
          <div className={' border-gray-dark border-r-0 md:border-r-1'}>
            <div className={'pr-0 md:pr-30'}>
              There are a lot of things that need to be explained in this industry. The explainer video will come to the rescue. Real estate explainer
              animation will show everything easily. It will turn explanations into an interactive video, from searching for properties to closing a
              deal. It will educate your viewers effectively!
            </div>
          </div>
        </div>
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14  px-0 md:px-30 '}>Higher Engaging Solution</h3>
          <div className={'w-full  border-gray-dark border-r-0 md:border-r-1'}>
            <div className={' px-0 md:px-30 '}>
              Are you looking for an engaging solution? We can offer one. The solution is a good explanation. Add attractive visuals and dynamic
              content. Explanations in this way will keep your viewers interested. Real estate animated explainer videos will prove that there’s
              nothing hard in the real estate industry.
            </div>
          </div>
        </div>
        <div className={'w-30p block pl-0 md:pl-30 pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Multi-versatile Tool</h3>
          Simplifying and engaging are not all the things that can be done in an explainer video. One of the key benefits of this format is
          versatility. And that includes the topics, styles, and platforms. Real estate promotional videos can highlight any idea in this field. You
          can use them on social media, websites, and email campaigns. The shareability of the videos takes over social media.
        </div>
      </Slider>
    </>
  );
};
export default BenefitsRealEstate;
